import {AppHelper} from "../appHelper";
import {CommonApp, Entity, Metadata} from "../core/components/commonApp";
import GridOptions = kendo.ui.GridOptions;
import {Grid} from "../core/components/grid";
import {
    TaskExecutionInfo,
    ExecutionAssignmentInfo
} from "../resourcePlanningDialogs/resourcePlanningDeletionDialog";
import {Helper} from "../core/util/helper";
import {Button} from "../core/components/button";
import {MetaDataHelper} from "../core/util/metaDataHelper";
import {HTTPService, JsonResultClass} from "../core/util/httpManager";
import {NotificationHelper} from "../core/util/notificationHelper";
import {DialogHelper} from "../core/util/dialogHelper";
import {General} from "../../siteManagement/general";
import {RecurringTaskCancellingPreview} from "../taskGroup/taskGroup";
import { GridCustomToolBarButton } from "../core/components/toolBar";
import React from "react";

export const openCancellationView = async (entity: TaskPositionCancellingParam, cancelPosition: (p: TaskPositionCancellingParam, individualFields: {}) => Promise<boolean>) => {

    let cancelPreview = await HTTPService.get<JsonResultClass<RecurringTaskCancellingPreview>>(
        'RecurringTask/GetCancelPreview?taskId=' + encodeURIComponent(entity.PositionId));

    if (cancelPreview.Code == 0 && cancelPreview.Data != null) {
        if (cancelPreview.Data.TaskExecutionInfos.length == 0 && !cancelPreview.Data.ConfirmationRequired)
        {
            const isOk = await DialogHelper.confirm(Helper.getTranslation("WebCRM.Tasks.TaskGroup.Msg.CancelConfirmation"));
            if (isOk)
                await cancelPosition(entity, cancelPreview.Data.IndividualFields);
            return;
        }

        let metaData = await Helper.getMetaData("taskCancellingPreview");

        let cancellationEntity = {...Helper.createEmptyEntity(),
            ...cancelPreview.Data,
            PositionToCancel: entity,
            CancelFromDate: new Date(),
            ExecutionCancellingComment: ""};

        const props: TaskCancellingPreviewProps = {
            entity: cancellationEntity,
            cancelPosition: cancelPosition,
            metadata: metaData,
            title: "",
            context: {}
        };

        const sheet = General.Sheet.Manager.createSheet();

        sheet.show(() => {
            sheet.mountContent(TaskCancellingPreviewApp, props);
        });
    } else {
        NotificationHelper.showErrorMessage(cancelPreview.Message);
    }
}

export class TaskCancellingPreviewApp extends React.Component<TaskCancellingPreviewProps, TaskCancellingPreviewState> {
    private common = new AppHelper();
    private assignmentsGridOptions: GridOptions;
    private executionsGridOptions: GridOptions;
    
    buildState(entity: TaskCancellingPreviewEntity): TaskCancellingPreviewState {
        return { selectedExecutionIds: [], //selectedAssignmentIds: [],
            ExecutionsToCancelCount: 0,
            TaskExecutionInfos: entity.TaskExecutionInfos.map(e => {
                return {...e,
                    action: TaskExecutionAction.LeaveItAsIs,
                    actionTranslation: Helper.getTranslation("Field.Enum.TaskExecutionCancellingAction.LeaveItAsIs"),
                    ExecutionStateTranslated: Helper.getTranslation("Field.Enum.ExecutionState." + e.ExecutionState)
                }
            }),
            ExecutionAssignments: entity.ExecutionAssignments.map(a => {
                return {...a,
                    action: AssignmentAction.LeaveItAsIs,
                    actionTranslation: Helper.getTranslation("Field.Enum.ExecutionAssignmentCancellingAction.LeaveItAsIs")
                }
            })
        };
    }
    
    constructor(props: TaskCancellingPreviewProps) {
        super(props);
        this.state = this.buildState(props.entity);
        this.common.enableHooks = true;
        this.common.init(this);
    }

    private handleFieldChange = (field: { model: string }, value: any, dataItem = null, isInit = false) => {
        if (!isInit) {
            if (field.model == "entity.CancelFromDate") {
                MetaDataHelper.setFieldValue(this.props.entity, field.model, value);
            }
            else
                this.common.handleFieldChange(field, value, dataItem);
        }
    }

    save = async () => {
        let shouldCancelPosition = false;
        if (!this.common.validate())
            return;
        
        if (this.state.ExecutionsToCancelCount == 0)
            shouldCancelPosition = true;
        else 
        {
            let ids = this.state.TaskExecutionInfos
                .filter(e => e.action == TaskExecutionAction.Cancel)
                .map(e => e.ExecutionId);
            let result = await HTTPService.post<JsonResultClass<{ Failed: number }>>("Executions/CancelExecutions", {
                executionIds: ids,
                comment: this.props.entity.ExecutionCancellingComment
            });
            if (result.Code === 0) {
                if (Helper.hasValue(result.Message)) {
                    NotificationHelper.showInfoMessage(result.Message.split("\r\n").join("<br/>"));
                }
                shouldCancelPosition = result.Data.Failed == 0;
                if (result.Data.Failed > 0) {
                    // Daten neu laden?...
                    let cancelPreview = await HTTPService.get<JsonResultClass<RecurringTaskCancellingPreview>>(
                    'RecurringTask/GetCancelPreview?taskId=' + encodeURIComponent(this.props.entity.PositionToCancel.PositionId));
                    if (cancelPreview.Code != 0) {
                        NotificationHelper.showErrorMessage(cancelPreview.Message);
                        return;
                    }
                    
                    // update entity...
                    // todo - wie war es noch mals mit dem entity-update?
                    let updatedEntity = this.props.entity;
                    updatedEntity.TaskExecutionInfos = cancelPreview.Data.TaskExecutionInfos;
                    updatedEntity.ExecutionAssignments = cancelPreview.Data.ExecutionAssignments;
                    //this.common.updateEntity(updatedEntity);
                    this.setState(this.buildState(updatedEntity));
                }
            }
            else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        }

        if (!shouldCancelPosition) return;
        
        let cancellingPositionResult = await this.props.cancelPosition(this.props.entity.PositionToCancel, this.props.entity.IndividualFields);
        if (cancellingPositionResult)
        {
            this.common.setEntityDirtyState(false);
            this.common.sheetWrapper.hide();
        }
    }

    // noinspection JSUnusedGlobalSymbols
    renderFilter = () => {
        let executionsToBeCancelled = this.state.TaskExecutionInfos.filter(e => e.action == TaskExecutionAction.Cancel).length;
        let assignmentsToBeDeleted = this.state.ExecutionAssignments.filter(ea => ea.action == AssignmentAction.Delete).length;
        let executionsText = Helper.getTranslation("WebCRM.Tasks.TaskGroup.Msg.Cancelling.ExecutionsCount_a1").replace("{executionsCount}", executionsToBeCancelled.toString());
        let executionsOverviewDiv = (<div style={{ margin: "10px", fontSize: "1.2em" }}>
            <i className="fal fa-multiply"/>&nbsp;{executionsText}
        </div>);
        if (executionsToBeCancelled == 0)
            executionsOverviewDiv = null;
        let assignmentsText = Helper.getTranslation("WebCRM.Tasks.TaskGroup.Msg.Cancelling.AssignmentsCount_a1").replace("{assignmentsCount}", assignmentsToBeDeleted.toString());
        let assignmentsOverviewDiv = (<div style={{ margin: "10px", fontSize: "1.2em" }}>
            <i className="fal fa-trash"/>&nbsp;{assignmentsText}
        </div>)
        if (assignmentsToBeDeleted == 0)
            assignmentsOverviewDiv = null;
        
        let executions = this.state.TaskExecutionInfos.length;
        let assignments = this.state.ExecutionAssignments.length;
        
        let unchangedText = Helper.getTranslation("WebCRM.Tasks.TaskGroup.Msg.Cancelling.ExecutionsAndAssignmentsUnchanged_a2")
            .replace("{executionsCount}", executions.toString()).replace("{assignmentsCount}", assignments.toString());
        let nothingDiv = (<div style={{ margin: "10px", fontSize: "1.2em" }}>
            <i className="fal fa-triangle-exclamation"/>&nbsp;{unchangedText}
        </div>);
        if (executionsToBeCancelled != 0 || assignmentsToBeDeleted != 0 || this.state.TaskExecutionInfos.length == 0)
            nothingDiv = null;
        
        let warningDiv = (
            <div style={{ margin: "10px 0", fontSize: "1.2em" }}>
                {Helper.getTranslation("WebCRM.Tasks.TaskGroup.Msg.Cancelling.ExecutionsAvailableWarning")}
            </div>);
        if (this.state.TaskExecutionInfos.length == 0)
            warningDiv = null;

        return (<div style={{display: "flex", flexDirection: "column"}}>
            {warningDiv}
            {nothingDiv}
            {executionsOverviewDiv}
            {assignmentsOverviewDiv}
        </div>);
    }

    
    // noinspection JSUnusedGlobalSymbols
    renderCancelExecButton = () => {
        return (<div><Button
            iconName="arrows-spin"
            handleClick={this.scheduleForCancelling}
            text={Helper.getTranslation("WebCRM.Tasks.TaskGroup.Action.Cancel")}
            buttonStyle={{
                width: "60%",
                height: "30px",
                border: "solid 1px #bdbdbd",
                borderRadius: "var(--border-radius)",
                margin: "10px 0"
            }}
            readOnly={false}/>
        </div>);
    }

    scheduleForCancelling = () => {
        let cancelForDate = Helper.dates.removeTime(this.props.entity.CancelFromDate);
        let executionsToBeCancelled = this.state.TaskExecutionInfos
            .filter(te => te.ExecutionState != "Finished" && te.ExecutionState != "Cancelled")
            .filter(e => kendo.parseDate(e.TriggeredForDate) >= cancelForDate );
        this.cancelExecutions(executionsToBeCancelled);
    }

    // noinspection JSUnusedGlobalSymbols
    commentVisible = () => {
        return this.state.ExecutionsToCancelCount > 0;
    }
    
    private cancelExecutions(executionsToBeCancelled: TaskExecutionInfoWithAction[]) {
        let assignments = this.state.ExecutionAssignments.map(ea => {
            let action = executionsToBeCancelled.find(e => e.ExecutionId == ea.ExecutionId) ? AssignmentAction.Delete : ea.action;
            let actionTranslation = action == AssignmentAction.Delete ? Helper.getTranslation("Field.Enum.ExecutionAssignmentCancellingAction.Delete") : ea.actionTranslation;
            return {
                ...ea,
                action: action,
                actionTranslation: actionTranslation
            }
        });
        let executions = this.state.TaskExecutionInfos.map(e => {
            return executionsToBeCancelled.find(ec => ec.ExecutionId == e.ExecutionId) ? {
                ...e,
                action: TaskExecutionAction.Cancel,
                actionTranslation: Helper.getTranslation("Field.Enum.TaskExecutionCancellingAction.Cancel")
            } : e;
        });
        let executionsToCancelCount = executions.filter(e => e.action == TaskExecutionAction.Cancel).length;
        
        this.setState({TaskExecutionInfos: executions, ExecutionAssignments: assignments, ExecutionsToCancelCount: executionsToCancelCount});
    }

    private undoCancelExecutions(executionsToBeCancelled: TaskExecutionInfoWithAction[]) {
        let assignments = this.state.ExecutionAssignments.map(ea => {
            let action = executionsToBeCancelled.find(e => e.ExecutionId == ea.ExecutionId) ? AssignmentAction.LeaveItAsIs : ea.action;
            let actionTranslation = action == AssignmentAction.LeaveItAsIs ? "" : ea.actionTranslation;
            return {
                ...ea,
                action: action,
                actionTranslation: actionTranslation
            }
        });
        let executions = this.state.TaskExecutionInfos.map(e => {
            return executionsToBeCancelled.find(ec => ec.ExecutionId == e.ExecutionId) ? {
                ...e,
                action: TaskExecutionAction.LeaveItAsIs,
                actionTranslation: ""
            } : e;
        });
        let executionsToCancelCount = executions.filter(e => e.action == TaskExecutionAction.Cancel).length;
        this.setState({TaskExecutionInfos: executions, ExecutionAssignments: assignments, ExecutionsToCancelCount: executionsToCancelCount});
    }

    onExecutionSelectionChanged = (data: any) => {
        if (data == null) {
            this.setState({ selectedExecutionIds: [] });
        }
        else if (Array.isArray(data)) {
            this.setState({ selectedExecutionIds: data.map(d => d.ExecutionId ) });
        }
        else { // wenn nur einer gewählt
            this.setState({ selectedExecutionIds: [data.ExecutionId] } );
        }
        
    }
    
    // noinspection JSUnusedGlobalSymbols
    renderExecutionsGrid = () => {
        
        const data = this.state.TaskExecutionInfos;

        if (data.length == 0) return null;

        let someOfExecutionsNotCancelled = this.state.TaskExecutionInfos
            .filter(te => te.ExecutionState != "Finished" && te.ExecutionState != "Cancelled")
            .find(te => te.action != TaskExecutionAction.Cancel && this.state.selectedExecutionIds.indexOf(te.ExecutionId) >= 0) != null;
        let someOfExecutionsCancelled = this.state.TaskExecutionInfos.find(te => te.action == TaskExecutionAction.Cancel && this.state.selectedExecutionIds.indexOf(te.ExecutionId) >= 0) != null;

        const customButtons: Array<GridCustomToolBarButton> = [];
        customButtons.push({
            id: "cancelBtn",
            enabled: someOfExecutionsNotCancelled,
            caption: Helper.getTranslation("Field.Enum.TaskExecutionCancellingAction.Cancel"),
            iconClass: "fa-solid fa-multiply",
            autoEnabledOnRecordSelected: false
        });

        customButtons.push({
            id: "keepBtn",
            enabled: someOfExecutionsCancelled,
            caption: Helper.getTranslation("WebCRM.Administration.ModButtonUndo"),
            iconClass: "fa-solid fa-eraser",
            autoEnabledOnRecordSelected: false
        });
        
        return (
            <div className="flex-container">
                <Grid
                    data={data}
                    customButtons={customButtons}
                    onClickCustomButton={this._handleCustomExecutionButton}
                    options={this.executionsGridOptions}
                    onSelectionChanged={this.onExecutionSelectionChanged}
                    id="executionsCancellingGrid"
                />

            </div>
        );
    }
    
    // noinspection JSUnusedGlobalSymbols
    renderAssignmentsGrid = () => {
        let data = [...this.state.ExecutionAssignments];
        if (this.state.selectedExecutionIds.length > 0) {
            data = data.filter(ea => this.state.selectedExecutionIds.find(v => v == ea.ExecutionId));
        }

        if (data.length == 0) return null;
        
        return (
            <div className="flex-container">
                <Grid
                    data={data}
                    options={this.assignmentsGridOptions}
                    id="executionAssignmentsCancellingGrid"
                />

            </div>
        );
    }

    private _handleCustomExecutionButton = (id: string, dataItem: TaskExecutionInfoWithAction | TaskExecutionInfoWithAction[]) => {
        if (id === "cancelBtn") {
            if (Array.isArray(dataItem)){
                let executionsToBeCancelled = dataItem
                    .filter(te => te.ExecutionState != "Finished" && te.ExecutionState != "Cancelled")
                    .filter(t => t.action != TaskExecutionAction.Cancel);
                this.cancelExecutions(executionsToBeCancelled);
            } else if (dataItem.action != TaskExecutionAction.Cancel && dataItem.ExecutionState != "Finished" && dataItem.ExecutionState != "Cancelled"){
                this.cancelExecutions([dataItem]);
            }
        } else if (id === "keepBtn") {
            if (Array.isArray(dataItem)){
                let executionsToBeCancelled = dataItem
                    .filter(t => t.action == TaskExecutionAction.Cancel);
                this.undoCancelExecutions(executionsToBeCancelled);
            } else if (dataItem.action == TaskExecutionAction.Cancel){
                this.undoCancelExecutions([dataItem]);
            }
        }
    } 
        
    render(){
        const props = $.extend({},
            this.props,
            this.common.getHandlersForProps(),
            {
                apphelper: this.common,
                handleFieldChange: this.handleFieldChange,
                title: "",
                context: {},
            });
        return <CommonApp {...props} />;
    }
}

export interface TaskCancellingPreviewProps {
    entity: TaskCancellingPreviewEntity;
    context: {}
    title: string;
    metadata: Metadata;
    cancelPosition: (entity: TaskPositionCancellingParam, individualFields: {}) => Promise<boolean>;
}

enum TaskExecutionAction {
    LeaveItAsIs,
    Cancel = 1
}

enum AssignmentAction {
    LeaveItAsIs,
    Delete = 1
}

interface TaskCancellingPreviewState {
    selectedExecutionIds: string[]
    TaskExecutionInfos: TaskExecutionInfoWithAction[];
    ExecutionAssignments: ExecutionAssignmentInfoWithAction[];
    ExecutionsToCancelCount: number;
}

interface TaskExecutionInfoWithAction extends TaskExecutionInfo {
    action: TaskExecutionAction,
    actionTranslation: string;
}

interface ExecutionAssignmentInfoWithAction extends ExecutionAssignmentInfo {
    action: AssignmentAction
    actionTranslation: string;
}

export interface TaskPositionCancellingParam {
    IsGroupNode: boolean;
    Level: number;
    // ist dann Task.Id oder TaskGroup.Id je nach IsGroupNode.
    PositionId: string;
    PositionNo: string;
    PositionTitle: string;
}

export interface TaskCancellingPreviewEntity extends Entity {
    TaskExecutionInfos: TaskExecutionInfo[];
    ExecutionAssignments: ExecutionAssignmentInfo[];
    CancelFromDate: string | Date;
    ExecutionCancellingComment: string;
    PositionToCancel: TaskPositionCancellingParam;
}